import {
  AgeGroup,
  AgeGroupFrequencyInput,
  AttendanceFrequencyInput,
  FrequencyTypeEnum,
  ResponsibleTypeEnum,
} from '@schooly/api';

export const selectUnconfiguredAgeGroups = (ageGroups: AgeGroup[]): AgeGroup[] =>
  ageGroups.filter((ageGroup) => !ageGroup.archived && ageGroup.attendance_frequency == null);

export const buildFrequencyConfigPayload = (
  frequencyById: Record<string, AttendanceFrequencyInput>,
): AgeGroupFrequencyInput[] =>
  Object.entries(frequencyById).map(([id, attendance_frequency]) => ({ id, attendance_frequency }));

export type TimetableWarningItem = 'am' | 'pm' | 'per_period';

/**
 * Registers that will not be created until a timetable is published.
 * AM or PM registers depend on a timetable when a subject teacher is responsible;
 * per-period registers always depend on a timetable when enabled.
 */
export const getTimetableWarningItems = (frequency: {
  frequency: FrequencyTypeEnum;
  am_responsible?: ResponsibleTypeEnum | null;
  pm_responsible?: ResponsibleTypeEnum | null;
  per_period_enabled?: boolean | null;
}): TimetableWarningItem[] => {
  const items: TimetableWarningItem[] = [];
  if (frequency.am_responsible === ResponsibleTypeEnum.SubjectTeacher) items.push('am');
  if (
    frequency.frequency === FrequencyTypeEnum.AmPm &&
    frequency.pm_responsible === ResponsibleTypeEnum.SubjectTeacher
  ) {
    items.push('pm');
  }
  if (frequency.per_period_enabled) items.push('per_period');
  return items;
};
